module.exports = __webpack_public_path__ + "img/BusinessName.6f68980b.svg";